<template>
  <div class="ai-visibility-questions-toolbar">
    <filter-chips
      :value="activeFilter"
      :filters="filters"
      :counts="filterCounts"
      @input="$emit('update:filter', $event)"
    />
    <ai-visibility-search-input
      :value="search"
      placeholder="Search questions"
      @input="$emit('update:search', $event)"
      @clear="$emit('update:search', '')"
    />
  </div>
</template>

<script>
import FilterChips from '../../../ui/controls/FilterChips.vue'
import AiVisibilitySearchInput from '../../../ui/controls/AiVisibilitySearchInput.vue'
import { QUESTION_FILTERS } from '../questionsData'

export default {
  name: 'QuestionsToolbar',
  components: {
    FilterChips,
    AiVisibilitySearchInput,
  },
  props: {
    activeFilter: {
      type: String,
      required: true,
    },
    filterCounts: {
      type: Object,
      required: true,
    },
    search: {
      type: String,
      default: '',
    },
  },
  computed: {
    filters () {
      return QUESTION_FILTERS
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-questions-toolbar {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.ai-visibility-questions-toolbar ::v-deep .ai-visibility-filter-chips {
  flex: 1 1 auto;
}

.ai-visibility-questions-toolbar ::v-deep .ai-visibility-search {
  flex: 0 1 280px;
}

@media (max-width: 760px) {
  .ai-visibility-questions-toolbar {
    align-items: flex-start;
  }

  .ai-visibility-questions-toolbar ::v-deep .ai-visibility-search {
    flex-basis: 100%;
    width: 100%;
  }
}
</style>
